import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Membership from "./pages/Membership";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import Calendar from "./pages/Calendar";
import LegalNotice from "./pages/LegalNotice";
import Terms from "./pages/Terms";
import Network from "./pages/Network";
import MemberLogin from "./pages/MemberLogin";
import Dashboard from "./pages/member/Dashboard";
import Flights from "./pages/member/Flights";
import MemberEvents from "./pages/member/MemberEvents";
import Stays from "./pages/member/Stays";
import EleganceNordique from "./pages/member/EleganceNordique";
import GrandPrixMonaco from "./pages/member/GrandPrixMonaco";
import GrandPrixHongrie from "./pages/member/GrandPrixHongrie";
import GrandPrixPaysBas from "./pages/member/GrandPrixPaysBas";
import GrandPrixItalie from "./pages/member/GrandPrixItalie";
import Seminaires from "./pages/member/Seminaires";
import SeminaireMarcoPolo from "./pages/member/SeminaireMarcoPolo";
import AfterWork from "./pages/member/AfterWork";
import AfterWorkParis from "./pages/member/AfterWorkParis";
import AfterWorkMonaco from "./pages/member/AfterWorkMonaco";

// Admin pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ManageMembers from "./pages/admin/ManageMembers";
import ManageFlights from "./pages/admin/ManageFlights";
import AddEditMember from "./pages/admin/AddEditMember";
import AddEditFlight from "./pages/admin/AddEditFlight";
import QuoteRequests from "./pages/admin/QuoteRequests";
import ManageBookings from "./pages/admin/ManageBookings";
import ManageStays from "./pages/admin/ManageStays";
import AddEditStay from "./pages/admin/AddEditStay";
import ManageEvents from "./pages/admin/ManageEvents";
import AddEditEvent from "./pages/admin/AddEditEvent";
import ManageAfterWorks from "./pages/admin/ManageAfterWorks";
import AddEditAfterWork from "./pages/admin/AddEditAfterWork";
import ManageBookingsNew from "./pages/admin/ManageBookingsNew";
import AdminProtectedRoute from "./components/AdminProtectedRoute";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App">
            <Navigation />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/events" element={<Events />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/legal" element={<LegalNotice />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/network" element={<Network />} />
              <Route path="/member-login" element={<MemberLogin />} />
              
              {/* Protected Member Routes */}
              <Route path="/member/dashboard" element={
                <ProtectedRoute><Dashboard /></ProtectedRoute>
              } />
              <Route path="/member/flights" element={
                <ProtectedRoute><Flights /></ProtectedRoute>
              } />
              <Route path="/member/events" element={
                <ProtectedRoute><MemberEvents /></ProtectedRoute>
              } />
              <Route path="/member/stays" element={
                <ProtectedRoute><Stays /></ProtectedRoute>
              } />
              <Route path="/member/elegance-nordique" element={
                <ProtectedRoute><EleganceNordique /></ProtectedRoute>
              } />
              <Route path="/member/grand-prix-monaco" element={
                <ProtectedRoute><GrandPrixMonaco /></ProtectedRoute>
              } />
              <Route path="/member/grand-prix-hongrie" element={
                <ProtectedRoute><GrandPrixHongrie /></ProtectedRoute>
              } />
              <Route path="/member/grand-prix-pays-bas" element={
                <ProtectedRoute><GrandPrixPaysBas /></ProtectedRoute>
              } />
              <Route path="/member/grand-prix-italie" element={
                <ProtectedRoute><GrandPrixItalie /></ProtectedRoute>
              } />
              <Route path="/member/seminaires" element={
                <ProtectedRoute><Seminaires /></ProtectedRoute>
              } />
              <Route path="/member/seminaire-marco-polo" element={
                <ProtectedRoute><SeminaireMarcoPolo /></ProtectedRoute>
              } />
              <Route path="/member/afterwork" element={
                <ProtectedRoute><AfterWork /></ProtectedRoute>
              } />
              <Route path="/member/afterwork-paris" element={
                <ProtectedRoute><AfterWorkParis /></ProtectedRoute>
              } />
              <Route path="/member/afterwork-monaco" element={
                <ProtectedRoute><AfterWorkMonaco /></ProtectedRoute>
              } />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>
              } />
              <Route path="/admin/members" element={
                <AdminProtectedRoute><ManageMembers /></AdminProtectedRoute>
              } />
              <Route path="/admin/members/add" element={
                <AdminProtectedRoute><AddEditMember /></AdminProtectedRoute>
              } />
              <Route path="/admin/members/edit/:memberId" element={
                <AdminProtectedRoute><AddEditMember /></AdminProtectedRoute>
              } />
              <Route path="/admin/flights" element={
                <AdminProtectedRoute><ManageFlights /></AdminProtectedRoute>
              } />
              <Route path="/admin/flights/add" element={
                <AdminProtectedRoute><AddEditFlight /></AdminProtectedRoute>
              } />
              <Route path="/admin/flights/edit/:flightId" element={
                <AdminProtectedRoute><AddEditFlight /></AdminProtectedRoute>
              } />
              <Route path="/admin/quotes" element={
                <AdminProtectedRoute><QuoteRequests /></AdminProtectedRoute>
              } />
              <Route path="/admin/bookings" element={
                <AdminProtectedRoute><ManageBookingsNew /></AdminProtectedRoute>
              } />
              <Route path="/admin/stays" element={
                <AdminProtectedRoute><ManageStays /></AdminProtectedRoute>
              } />
              <Route path="/admin/stays/add" element={
                <AdminProtectedRoute><AddEditStay /></AdminProtectedRoute>
              } />
              <Route path="/admin/stays/edit/:stayId" element={
                <AdminProtectedRoute><AddEditStay /></AdminProtectedRoute>
              } />
              <Route path="/admin/events" element={
                <AdminProtectedRoute><ManageEvents /></AdminProtectedRoute>
              } />
              <Route path="/admin/events/add" element={
                <AdminProtectedRoute><AddEditEvent /></AdminProtectedRoute>
              } />
              <Route path="/admin/events/edit/:eventId" element={
                <AdminProtectedRoute><AddEditEvent /></AdminProtectedRoute>
              } />
              <Route path="/admin/afterworks" element={
                <AdminProtectedRoute><ManageAfterWorks /></AdminProtectedRoute>
              } />
              <Route path="/admin/afterworks/add" element={
                <AdminProtectedRoute><AddEditAfterWork /></AdminProtectedRoute>
              } />
              <Route path="/admin/afterworks/edit/:afterworkId" element={
                <AdminProtectedRoute><AddEditAfterWork /></AdminProtectedRoute>
              } />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
